module.exports = __webpack_public_path__ + "img/Terranova_Img1.212ea483.png";